import { render, staticRenderFns } from "./VanDerWaalsForceViz.vue?vue&type=template&id=380c541b&scoped=true"
import script from "./VanDerWaalsForceViz.vue?vue&type=script&lang=js"
export * from "./VanDerWaalsForceViz.vue?vue&type=script&lang=js"
import style0 from "./VanDerWaalsForceViz.vue?vue&type=style&index=0&id=380c541b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c541b",
  null
  
)

export default component.exports